export const ACTIONS_MENU_ITEM_DATA_HOOK = 'actions-menu-item';

export const ACTIONS_MENU_E2E_DATA_HOOK = 'storybook-e2e-actions-menu';

export { ActionsMenuLayoutDataHooks as ACTIONS_MENU_DATA_KEYS } from './types';
